import React from "react";

function getNoResult() {
  return <div>No Records Found</div>;
}

export default getNoResult;



// WEBPACK FOOTER //
// ./src/components/searchresults/NoResult.js